import { InputAdornment } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { convertToMinMaxNumber } from "lib/number"
import { getCurrencySymbol } from "./currency-symbol"

/**
 * Recipient input for a `currency` requested field. Numeric text field bound to `values.<field.id>`
 * with a leading currency symbol derived from `field.currencyCode`, clamped to a minimum of 0.
 *
 * @param {object} props
 * @param {{ id: string, currencyCode?: string }} props.field
 */
export function CurrencyFieldInput({ field }) {
    return (
        <BoundTextField
            field={`values.${field.id}`}
            noLabel
            type="number"
            size="small"
            transformOut={convertToMinMaxNumber(0)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">{getCurrencySymbol(field.currencyCode)}</InputAdornment>
                ),
            }}
        />
    )
}
